module.exports = __webpack_public_path__ + "assets/img/6.e47a1c16.png";